import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'



class Dedicados extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }
      
    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #fff;
            padding: 150px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 1300px 0 50px 0;
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 50px 0 50px 0;              
            }
        `

        const ServiceRow = styled(Row)`
            margin-top: 50px;
        `

        const ServiceHeading = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
            margin-bottom: 0px;
        `

        const ServiceHeadinga = styled.a`
            font-family: Oswald;
            color: #78c91c;
            transition: .5s;
            &:hover {
              color: #1a1a1a;
              text-decoration: none;
            }
        `

        const ServiceSeparator = styled.div`
            height: 2px;
            width: 50px;
            background-color: #84a841;
            margin-bottom: 5px;
        `

        const ServiceLinea = styled.div`
            height: 1px;
            width: 200px;
            background-color: #808080;
            margin: 2px 0 7px 0;
         `

         const ServiceNumber = styled.p`
            position: absolute;
            font-size: 30px;
            color: #717171;
            font-weight: 900;
            top: -50px;
            opacity: .1;
            z-index: -1;
            transition: .2s;
         `

         const ServiceElement = styled.div`
            margin-bottom: 90px;
            border-radius: 20px;
            transition: .2s;
            position: relative;
            &:hover ${ServiceNumber} {
                opacity: .3 !important;
                color: #65ff00;
            }
        `
         
         const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #808080;
            padding-right: 25px;            
        `

         const ServicePrecio = styled.p`
            font-size: 30px;
            font-weight: 300;
            color: #78c91c;
            padding-right: 25px;            
        `        

        const Submit = styled.a`
            background-color: #fff !important;
            color: #4b7d2f !important;
            border: solid 1px #4b7d2f;
            cursor: pointer !important;
            border-radius: 3px;
            font-size: 14px;
            line-height: 1;
            margin: 0;
            padding: 17px 26px;
            position: relative;
            letter-spacing: 0.02em;
            font-family: "Open Sans Semibold";
            box-shadow: 0 2px 8px 0 rgba(62, 62, 79, .23);
	        -webkit-transition: all 300ms linear 0ms;
	        -moz-transition: all 300ms linear 0ms;
	        -ms-transition: all 300ms linear 0ms;
            transition: all 300ms linear 0ms;
            display: inline-block;
            font-weight: 400;            
            text-transform: uppercase;          
            &:hover {              
                transform: translateX(-20%);
                text-decoration: none;
                background-color: #c1eb18 !important;
	            color: #000 !important;
	            border: none;
                box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .30);
	            -webkit-transform: translateY(-5px);
	            transform: translateY(-5px);              
            }            
        `

        const Color = styled.span`            
            font-weight: bold;
            color: #6c6c6c;            
        `        

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 20px;
        `        
        const Heading2b = styled.h2`
            font-size: 70px;
            font-family: Poppins;
            color: #1a1a1a;
            line-height: 80px;
            font-weight: 800;
            text-align: center;
            padding-bottom: 80px;
            @media (min-width:768px) and (max-width:1500px) {                
                padding-top: 200px;
            }
            @media (max-width: 767px) {
                font-size: 50px;           
            }
        `
        const Heading3 = styled.h3`
            font-size: 40px;
            font-family: Poppins;
            color: #84a841;
            line-height: 50px;
        `

        const Heading3b = styled.h3`
            font-size: 50px;
            font-family: Poppins;
            color: #84a841;
            line-height: 50px;
            margin-top: 150px;
        `
        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #808080;            
            margin: 30px;
            padding-top: 50px;
        `

        const Span = styled.span`
            font-size: 20px;
            font-weight: 300;
            color: #000000;            
        `

        const Element = styled.div`
      margin-bottom: 20px;
      text-align: center;
      img {
        max-height: 500px;
        max-width: 500px;
        width: 100%;
        height: auto;
      }
      transition: 0.2s;
      &:hover {
        transform: translateY(-10px);
      }
      @media (max-width: 767px) {
        width: 100%;          /* Ocupar todo el ancho de la pantalla */                    
        padding: 0;
        margin: 40px 0;            
        img {
          max-width: 100%;     /* Permitir que la imagen se estire a lo ancho */
          width: 100vw;        /* Igual que el viewport */
          height: auto;
          display: block;       /* Asegura que no tenga espacio extra por inline */          
        }        
      }
    `
        const ColorV = styled.span`            
            font-weight: bold;
            color: #c1eb18;            
        `

        const { data } = this.props;
        console.log(data)
        // Agregar verificación para asegurarse de que los datos están disponibles
        if (!data || !data.allPricesJson || !data.allPricesJson.nodes.length) {
            return <div>Loading...</div>;
        }

        const prices = data.allPricesJson.nodes[0].items;

        console.log(prices)

        return(
            <Section>
                <Container>
                    <Row>
                        <Col md={12}>
                            
                                <Heading2b>Servidores Dedicado<ColorV>s</ColorV></Heading2b>
                                <Separator />
                                <Heading3>Servidores dedicados NO administrados</Heading3>
                                <Text>
                                    Con un servidor dedicado no administrado, tú eres el administrador. Esto significa que tienes
                                    el control total sobre la configuración, instalación de software y personalización de acuerdo
                                    con tus necesidades específicas.
                                </Text>
                                <Heading3b>Servidor dedicado SSD</Heading3b>
                                <Row>
                                    <Col md={6}>
                                        
                                            <Text>
                                                En <Color>VASCO Solutions,</Color> llevamos la experiencia de servidor dedicado a un nivel superior al ofrecer
                                                la potencia y velocidad inigualables de nuestros servidores dedicados con discos SSD. Diseñados para
                                                satisfacer las demandas más intensas, estos servidores impulsarán tu presencia en línea
                                                con un rendimiento excepcional.
                                            </Text>
                                        
                                    </Col>
                                    <Col md={6}>
                                        
                                            <Element>
                                                <GatsbyImage image={this.props.image} alt="Servidor dedicado SSD" sizes="(max-width: 767px) 300px, 500px"  />
                                            </Element>
                                        
                                    </Col>
                                </Row>
                            
                        </Col>
                    </Row>
                    <ServiceRow>
                        <Col md={4}>
                            
                                <ServiceElement>
                                    <ServiceHeading>
                                        <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=259">
                                            Dedicado SSD 1
                                        </ServiceHeadinga>
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Intel Xeon D-2141 I
                                    </ServiceText>
                                    <ServiceText>
                                        <Color>16 Gb.</Color> RAM
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>500</Color> Gb. SSD de espacio en RAID 1
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>2,2 Ghz (8 núcleos/16 hilos)</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>5 Tb.</Color> de Ancho de banda
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        2 direcciones IP
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        AlmaLinux 8, 9, RockyLinux 8, 9, Ubuntu 20.04 y 22.04
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Acceso completo root
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Aprovisionamiento instantáneo
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Garantía de devolución <Color>30 días</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServicePrecio>
                                        ${prices.find(x => x.name === 'dssd 1').price}<Span>/mes</Span>
                                    </ServicePrecio>
                                    <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=259">
                                        <span>
                                            Contratar
                                        </span>
                                    </Submit>
                                </ServiceElement>
                            
                        </Col>
                        <Col md={4}>
                            
                                <ServiceElement>
                                    <ServiceHeading>
                                        <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=260">
                                            Dedicado SSD 2
                                        </ServiceHeadinga>
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Intel Xeon D-2141 I
                                    </ServiceText>
                                    <ServiceText>
                                        <Color>28 Gb.</Color> RAM
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>1.000</Color> Gb. SSD de espacio en RAID 1
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>2,2 Ghz (8 núcleos/16 hilos)</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>10 Tb.</Color> de Ancho de banda
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        2 direcciones IP
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        AlmaLinux 8, 9, RockyLinux 8, 9, Ubuntu 20.04 y 22.04
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Acceso completo root
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Aprovisionamiento instantáneo
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Garantía de devolución <Color>30 días</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServicePrecio>
                                        ${prices.find(x => x.name === 'dssd 2').price}<Span>/mes</Span>
                                    </ServicePrecio>
                                    <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=260">
                                        <span>
                                            Contratar
                                        </span>
                                    </Submit>
                                </ServiceElement>
                            
                        </Col>
                        <Col md={4}>
                            
                                <ServiceElement>
                                    <ServiceHeading>
                                        <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=261">
                                            Dedicado SSD 3
                                        </ServiceHeadinga>
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Intel Xeon D-2141 I
                                    </ServiceText>
                                    <ServiceText>
                                        <Color>60 Gb.</Color> RAM
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>1.790</Color> Gb. SSD de espacio en RAID 1
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>2,2 Ghz (8 núcleos/16 hilos)</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        <Color>15 Tb.</Color> de Ancho de banda
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        2 direcciones IP
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        AlmaLinux 8, 9, RockyLinux 8, 9, Ubuntu 20.04 y 22.04
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Acceso completo root
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Aprovisionamiento instantáneo
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServiceText>
                                        Garantía de devolución <Color>30 días</Color>
                                    </ServiceText>
                                    <ServiceLinea />
                                    <ServicePrecio>
                                        ${prices.find(x => x.name === 'dssd 3').price}<Span>/mes</Span>
                                    </ServicePrecio>
                                    <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=261">
                                        <span>
                                            Contratar
                                        </span>
                                    </Submit>
                                </ServiceElement>
                            
                        </Col>
                    </ServiceRow>
                </Container>
            </Section>
        )
    }
}

const PrecioImagen = (props) => (
    <StaticQuery
      query={graphql`
        query {
          allPricesJson(filter: { page: { eq: "dedicado" }, section: { eq: "planes" } }) {
            nodes {
              items {
                name
                price
              }
            }
          }
          file(relativePath: {eq: "disco-ssd.jpg"}) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 500
              )
            }
          }
        }
      `}
      render={(data) => {
        const image = getImage(data.file.childImageSharp.gatsbyImageData);
        return (
          <Dedicados
            data={data}
            image={image}
            {...props}
          />
        );
      }}
    />
  );
  
  export default PrecioImagen;
